package com.example.ramsembedded.pages

import androidx.compose.runtime.Composable
import com.example.ramsembedded.components.layouts.PageLayout
import com.varabyte.kobweb.core.Page

@Page
@Composable
fun ContactUsPage() {
    PageLayout("Contact Us") {
        ContactSectionCourses()
    }
}


